import WarehouseAdminProductCategoryData, {
    IWarehouseAdminProductCategoryData
} from "@/http/data/warehouse-admin-product-category-data";

import WarehouseAdminProductLocationData, {
    IWarehouseAdminProductLocationData
} from "@/http/data/warehouse-admin-product-location-data";

export interface IWarehouseAdminProductListData {
    id: number;
    name: string;
    description: string|null;
    warehouse: number;
    rack: string|null;
    layer: string|null;
    place: string|null;
    retour: boolean;
    category_id: number;
    category: IWarehouseAdminProductCategoryData|null;
    type_id: number;
    target_price: number|null;
    active: boolean;
    charge: boolean;
    min_stock: number|null;
    base_stock: number|null;
    restock_default: number;
    count: number;
    units: number|null;
    inventory_check: boolean;
    image: string|null;
    thumb: string|null;
    image_timestamp: string|null;
    thumbnailUrl: string|null;
    imageUrl: string|null;
    disabled_buildings: string[];
    locations: IWarehouseAdminProductLocationData[];
}

export default class WarehouseAdminProductListData {
    public id: number;
    public name: string;
    public description: string|null;
    public warehouse: number;
    public rack: string|null;
    public layer: string|null;
    public place: string|null;
    public retour: boolean;
    public category_id: number;
    public category: WarehouseAdminProductCategoryData|null;
    public type_id: number;
    public target_price: number|null;
    public active: boolean;
    public charge: boolean;
    public min_stock: number|null;
    public base_stock: number|null;
    public restock_default: number;
    public count: number;
    public units: number|null;
    public inventory_check: boolean;
    public image: string|null;
    public thumb: string|null;
    public image_timestamp: string|null;
    public thumbnailUrl: string|null;
    public imageUrl: string|null;
    public disabled_buildings: string[];
    public locations: WarehouseAdminProductLocationData[];

    constructor(data: IWarehouseAdminProductListData) {
        this.id = Number(data.id);
        this.name = data.name;
        this.description = data.description ?? null;
        this.warehouse = Number(data.warehouse);
        this.rack = data.rack ?? null;
        this.layer = data.layer ?? null;
        this.place = data.place ?? null;
        this.retour = Boolean(data.retour);
        this.category_id = Number(data.category_id);
        this.category = data.category
            ? new WarehouseAdminProductCategoryData(data.category)
            : null;
        this.type_id = Number(data.type_id);
        this.target_price = data.target_price === null
            ? null
            : Number(data.target_price);
        this.active = Boolean(data.active);
        this.charge = Boolean(data.charge);
        this.min_stock = data.min_stock === null
            ? null
            : Number(data.min_stock);
        this.base_stock = data.base_stock === null
            ? null
            : Number(data.base_stock);
        this.restock_default = Number(data.restock_default);
        this.count = Number(data.count);
        this.units = data.units === null
            ? null
            : Number(data.units);
        this.inventory_check = Boolean(data.inventory_check);
        this.image = data.image ?? null;
        this.thumb = data.thumb ?? null;
        this.image_timestamp = data.image_timestamp ?? null;
        this.thumbnailUrl = data.thumbnailUrl ?? null;
        this.imageUrl = data.imageUrl ?? null;
        this.disabled_buildings = Array.isArray(data.disabled_buildings)
            ? data.disabled_buildings
            : [];
        this.locations = (data.locations ?? []).map(
            location => new WarehouseAdminProductLocationData(location)
        );
    }
}